<template>
  <div class="flex min-h-screen w-full bg-app-sidebar max-sm:bg-white">
    <aside class="flex w-64 shrink-0 flex-col max-sm:hidden">
      <div class="mt-4 flex h-16 items-center gap-3 px-4">
        <div class="size-8 animate-pulse rounded-full bg-grey-200" />
        <div
          class="h-[18px] w-[110px] animate-pulse rounded-full bg-grey-200"
        />
      </div>

      <nav class="flex-1 overflow-hidden px-2 pb-4">
        <div v-for="section in 3" :key="section" class="mb-6">
          <div class="px-3 py-2">
            <div class="h-3 w-[90px] animate-pulse rounded-full bg-grey-200" />
          </div>
          <div
            v-for="item in 4"
            :key="item"
            class="flex items-center gap-3 px-3 py-1.5"
          >
            <div class="size-5 shrink-0 animate-pulse rounded bg-grey-200" />
            <div class="h-3 w-[140px] animate-pulse rounded-full bg-grey-200" />
          </div>
        </div>
      </nav>
    </aside>

    <div class="flex min-w-0 flex-1 flex-col">
      <header
        class="flex h-14 shrink-0 items-center gap-3 border-b border-app-separator bg-app-sidebar px-3 sm:hidden"
      >
        <div class="size-8 animate-pulse rounded bg-grey-200" />
        <div
          class="h-[18px] w-[110px] animate-pulse rounded-full bg-grey-200"
        />
      </header>

      <main class="flex-1 px-3 pb-4 pt-3 max-sm:p-0">
        <div
          class="min-h-full overflow-hidden rounded-lg border border-grey-200 bg-white shadow-[0_2px_12px_-4px_rgba(15,23,42,0.06)] max-sm:min-h-full max-sm:rounded-none max-sm:border-none max-sm:shadow-none"
        >
          <div class="p-4">
            <div
              class="mb-4 flex w-full flex-wrap items-center justify-between gap-y-2 p-1 sm:py-0"
            >
              <div class="flex min-h-10 min-w-0 grow items-center gap-2">
                <div
                  class="h-4 w-[80px] animate-pulse rounded-full bg-grey-200"
                />
                <div
                  class="h-4 w-[160px] animate-pulse rounded-full bg-grey-200"
                />
                <div
                  class="h-5 w-[60px] animate-pulse rounded-full bg-grey-200"
                />
              </div>
              <div
                class="order-last ml-0 flex min-h-10 w-full basis-full items-center justify-end self-center sm:order-none sm:ml-auto sm:w-auto sm:basis-auto"
              >
                <div
                  class="h-9 w-[120px] animate-pulse rounded-lg bg-grey-200"
                />
              </div>
            </div>

            <div class="px-1">
              <UISkeletonLoaderDetailViewCards />
            </div>
          </div>
        </div>
      </main>
    </div>
  </div>
</template>

<script lang="ts" setup>
import UISkeletonLoaderDetailViewCards from './UISkeletonLoaderDetailViewCards.vue';
</script>

<style scoped lang="scss"></style>
